export enum Ability {
  DEFAULT = "DEFAULT",
  FIRE_BLAST = "FIRE_BLAST",
  WHEEL_OF_FIRE = "WHEEL_OF_FIRE",
  SEISMIC_TOSS = "SEISMIC_TOSS",
  GUILLOTINE = "GUILLOTINE",
  ROCK_SLIDE = "ROCK_SLIDE",
  HEAT_WAVE = "HEAT_WAVE",
  THUNDER = "THUNDER",
  HYDRO_PUMP = "HYDRO_PUMP",
  DRACO_METEOR = "DRACO_METEOR",
  BLAZE_KICK = "BLAZE_KICK",
  WISH = "WISH",
  CALM_MIND = "CALM_MIND",
  DEFENSE_CURL = "DEFENSE_CURL",
  IRON_DEFENSE = "IRON_DEFENSE",
  METRONOME = "METRONOME",
  SOAK = "SOAK",
  IRON_TAIL = "IRON_TAIL",
  BLAST_BURN = "BLAST_BURN",
  CHARGE = "CHARGE",
  DISCHARGE = "DISCHARGE",
  BITE = "BITE",
  DRAGON_TAIL = "DRAGON_TAIL",
  DRAGON_BREATH = "DRAGON_BREATH",
  ICICLE_CRASH = "ICICLE_CRASH",
  ROOT = "ROOT",
  TORMENT = "TORMENT",
  STOMP = "STOMP",
  PAYBACK = "PAYBACK",
  NIGHT_SLASH = "NIGHT_SLASH",
  BUG_BUZZ = "BUG_BUZZ",
  STRING_SHOT = "STRING_SHOT",
  VENOSHOCK = "VENOSHOCK",
  LEECH_LIFE = "LEECH_LIFE",
  HAPPY_HOUR = "HAPPY_HOUR",
  TELEPORT = "TELEPORT",
  NASTY_PLOT = "NASTY_PLOT",
  THIEF = "THIEF",
  STUN_SPORE = "STUN_SPORE",
  METEOR_MASH = "METEOR_MASH",
  HURRICANE = "HURRICANE",
  BURN = "BURN",
  SILENCE = "SILENCE",
  SLEEP = "SLEEP",
  PROTECT = "PROTECT",
  POISON = "POISON",
  CONFUSION = "CONFUSION",
  ORIGIN_PULSE = "ORIGIN_PULSE",
  SEED_FLARE = "SEED_FLARE",
  HEAL_BLOCK = "HEAL_BLOCK",
  ROAR_OF_TIME = "ROAR_OF_TIME",
  ROCK_TOMB = "ROCK_TOMB",
  ROCK_SMASH = "ROCK_SMASH",
  HEAD_SMASH = "HEAD_SMASH",
  VOLT_SWITCH = "VOLT_SWITCH",
  SHADOW_CLONE = "SHADOW_CLONE",
  HYPER_VOICE = "HYPER_VOICE",
  PETAL_DANCE = "PETAL_DANCE",
  ECHO = "ECHO",
  TRI_ATTACK = "TRI_ATTACK",
  GRASS_WHISTLE = "GRASS_WHISTLE",
  HIGH_JUMP_KICK = "HIGH_JUMP_KICK",
  DISARMING_VOICE = "DISARMING_VOICE",
  RELIC_SONG = "RELIC_SONG",
  GROWL = "GROWL",
  BONEMERANG = "BONEMERANG",
  CLANGOROUS_SOUL = "CLANGOROUS_SOUL",
  NIGHTMARE = "NIGHTMARE",
  EXPLOSION = "EXPLOSION",
  KING_SHIELD = "KING_SHIELD",
  CORRUPTED_NATURE = "CORRUPTED_NATURE",
  CRABHAMMER = "CRABHAMMER",
  DIAMOND_STORM = "DIAMOND_STORM",
  DRACO_ENERGY = "DRACO_ENERGY",
  DYNAMAX_CANNON = "DYNAMAX_CANNON",
  DYNAMIC_PUNCH = "DYNAMIC_PUNCH",
  ELECTRO_BOOST = "ELECTRO_BOOST",
  ELECTRO_WEB = "ELECTRO_WEB",
  FIRE_TRICK = "FIRE_TRICK",
  FLAME_CHARGE = "FLAME_CHARGE",
  LEECH_SEED = "LEECH_SEED",
  LOCK_ON = "LOCK_ON",
  PSYCH_UP = "PSYCH_UP",
  RAZOR_WIND = "RAZOR_WIND",
  TWISTING_NETHER = "TWISTING_NETHER",
  WONDER_GUARD = "WONDER_GUARD",
  SONG_OF_DESIRE = "SONG_OF_DESIRE",
  CONFUSING_MIND = "CONFUSING_MIND",
  KNOWLEDGE_THIEF = "KNOWLEDGE_THIEF",
  EARTHQUAKE = "EARTHQUAKE",
  SOFT_BOILED = "SOFT_BOILED",
  ELECTRIC_SURGE = "ELECTRIC_SURGE",
  PSYCHIC_SURGE = "PSYCHIC_SURGE",
  MIND_BLOWN = "MIND_BLOWN",
  PAYDAY = "PAYDAY",
  BEAT_UP = "BEAT_UP",
  BLUE_FLARE = "BLUE_FLARE",
  FUSION_BOLT = "FUSION_BOLT",
  AURORA_VEIL = "AURORA_VEIL",
  AQUA_JET = "AQUA_JET",
  JUDGEMENT = "JUDGEMENT",
  CHATTER = "CHATTER",
  LIQUIDATION = "LIQUIDATION",
  STEAM_ERUPTION = "STEAM_ERUPTION",
  APPLE_ACID = "APPLE_ACID",
  SHADOW_BALL = "SHADOW_BALL",
  DIVE = "DIVE",
  SPIKE_ARMOR = "SPIKE_ARMOR",
  FUTURE_SIGHT = "FUTURE_SIGHT",
  FAKE_TEARS = "FAKE_TEARS",
  SPARKLING_ARIA = "SPARKLING_ARIA",
  DRAGON_DARTS = "DRAGON_DARTS",
  GRASSY_SURGE = "GRASSY_SURGE",
  MISTY_SURGE = "MISTY_SURGE",
  SKY_ATTACK = "SKY_ATTACK",
  ILLUSION = "ILLUSION",
  SLUDGE = "SLUDGE",
  AURORA_BEAM = "AURORA_BEAM",
  AGILITY = "AGILITY",
  SPIRIT_SHACKLE = "SPIRIT_SHACKLE",
  WATER_SHURIKEN = "WATER_SHURIKEN",
  SHADOW_SNEAK = "SHADOW_SNEAK",
  MACH_PUNCH = "MACH_PUNCH",
  UPPERCUT = "UPPERCUT",
  TRIPLE_KICK = "TRIPLE_KICK",
  MAWASHI_GERI = "MAWASHI_GERI",
  FORECAST = "FORECAST",
  SACRED_SWORD = "SACRED_SWORD",
  X_SCISSOR = "X_SCISSOR",
  PLASMA_FIST = "PLASMA_FIST",
  SPECTRAL_THIEF = "SPECTRAL_THIEF",
  GEOMANCY = "GEOMANCY",
  DEATH_WING = "DEATH_WING",
  SLACK_OFF = "SLACK_OFF",
  DARK_VOID = "DARK_VOID",
  OVERHEAT = "OVERHEAT",
  HYPNOSIS = "HYPNOSIS",
  MIMIC = "MIMIC",
  HEX = "HEX",
  GROWTH = "GROWTH",
  HEAL_ORDER = "HEAL_ORDER",
  SHELL_TRAP = "SHELL_TRAP",
  DIG = "DIG",
  FIRE_SPIN = "FIRE_SPIN",
  SEARING_SHOT = "SEARING_SHOT",
  PECK = "PECK",
  SPLASH = "SPLASH",
  COUNTER = "COUNTER",
  COSMIC_POWER = "COSMIC_POWER",
  STICKY_WEB = "STICKY_WEB",
  SILVER_WIND = "SILVER_WIND",
  POISON_POWDER = "POISON_POWDER",
  ICY_WIND = "ICY_WIND",
  GIGATON_HAMMER = "GIGATON_HAMMER",
  ACROBATICS = "ACROBATICS",
  ABSORB = "ABSORB",
  ROLLOUT = "ROLLOUT",
  THRASH = "THRASH",
  SOLAR_BEAM = "SOLAR_BEAM",
  MAGMA_STORM = "MAGMA_STORM",
  SLASHING_CLAW = "SLASHING_CLAW",
  ERUPTION = "ERUPTION",
  MIST_BALL = "MIST_BALL",
  LUSTER_PURGE = "LUSTER_PURGE",
  MUD_BUBBLE = "MUD_BUBBLE",
  LINK_CABLE = "LINK_CABLE",
  MAGIC_BOUNCE = "MAGIC_BOUNCE",
  HIDDEN_POWER_A = "HIDDEN_POWER_A",
  HIDDEN_POWER_B = "HIDDEN_POWER_B",
  HIDDEN_POWER_C = "HIDDEN_POWER_C",
  HIDDEN_POWER_D = "HIDDEN_POWER_D",
  HIDDEN_POWER_E = "HIDDEN_POWER_E",
  HIDDEN_POWER_F = "HIDDEN_POWER_F",
  HIDDEN_POWER_G = "HIDDEN_POWER_G",
  HIDDEN_POWER_H = "HIDDEN_POWER_H",
  HIDDEN_POWER_I = "HIDDEN_POWER_I",
  HIDDEN_POWER_J = "HIDDEN_POWER_J",
  HIDDEN_POWER_K = "HIDDEN_POWER_K",
  HIDDEN_POWER_L = "HIDDEN_POWER_L",
  HIDDEN_POWER_M = "HIDDEN_POWER_M",
  HIDDEN_POWER_N = "HIDDEN_POWER_N",
  HIDDEN_POWER_O = "HIDDEN_POWER_O",
  HIDDEN_POWER_P = "HIDDEN_POWER_P",
  HIDDEN_POWER_Q = "HIDDEN_POWER_Q",
  HIDDEN_POWER_R = "HIDDEN_POWER_R",
  HIDDEN_POWER_S = "HIDDEN_POWER_S",
  HIDDEN_POWER_T = "HIDDEN_POWER_T",
  HIDDEN_POWER_U = "HIDDEN_POWER_U",
  HIDDEN_POWER_V = "HIDDEN_POWER_V",
  HIDDEN_POWER_W = "HIDDEN_POWER_W",
  HIDDEN_POWER_X = "HIDDEN_POWER_X",
  HIDDEN_POWER_Y = "HIDDEN_POWER_Y",
  HIDDEN_POWER_Z = "HIDDEN_POWER_Z",
  HIDDEN_POWER_QM = "HIDDEN_POWER_QM",
  HIDDEN_POWER_EM = "HIDDEN_POWER_EM",
  POISON_JAB = "POISON_JAB",
  SHELL_SMASH = "SHELL_SMASH",
  HELPING_HAND = "HELPING_HAND",
  ASTRAL_BARRAGE = "ASTRAL_BARRAGE",
  BLIZZARD = "BLIZZARD",
  WATERFALL = "WATERFALL",
  PYRO_BALL = "PYRO_BALL",
  WHIRLPOOL = "WHIRLPOOL",
  SMOKE_SCREEN = "SMOKE_SCREEN",
  PRESENT = "PRESENT",
  LEAF_BLADE = "LEAF_BLADE",
  ANCHOR_SHOT = "ANCHOR_SHOT",
  SMOG = "SMOG",
  PSYCHIC = "PSYCHIC",
  MAGNET_RISE = "MAGNET_RISE",
  ATTRACT = "ATTRACT",
  WATER_PULSE = "WATER_PULSE",
  PLAY_ROUGH = "PLAY_ROUGH",
  AERIAL_ACE = "AERIAL_ACE",
  PARABOLIC_CHARGE = "PARABOLIC_CHARGE",
  SUPER_FANG = "SUPER_FANG",
  TEETER_DANCE = "TEETER_DANCE",
  CLOSE_COMBAT = "CLOSE_COMBAT",
  ASSIST = "ASSIST",
  FISSURE = "FISSURE",
  ASSURANCE = "ASSURANCE",
  AQUA_RING = "AQUA_RING",
  POISON_GAS = "POISON_GAS",
  BRAVE_BIRD = "BRAVE_BIRD",
  MAGICAL_LEAF = "MAGICAL_LEAF",
  STEALTH_ROCKS = "STEALTH_ROCKS",
  STRUGGLE_BUG = "STRUGGLE_BUG",
  TAIL_GLOW = "TAIL_GLOW",
  PRISMATIC_LASER = "PRISMATIC_LASER",
  NATURAL_GIFT = "NATURAL_GIFT",
  NIGHT_SHADE = "NIGHT_SHADE"
}
